import React from 'react';

const Dts = () => {
  return (
    // Main Container - Padding aur Background image ke hisaab se
    <div className="bg-white min-h-screen p-6 md:p-12 font-sans text-[#4a4a4a]">
      
      {/* 1. Breadcrumb - Sabse upar (Exactly like image) */}
      <nav className="text-[15px] mb-8">
        <span className="text-[#337ab7] cursor-pointer hover:underline">Home</span>
        <span className="mx-1 text-gray-500"> » </span>
        <span className="text-gray-600">The Dental Technology Show (DTS)</span>
      </nav>

      <div className="max-w-7xl mx-auto">
        {/* 2. Main Heading */}
        <h1 className="text-4xl md:text-[42px] font-normal text-[#444] mb-6">
          The Dental Technology Show (DTS)
        </h1>
        
        {/* 3. Horizontal Gray Line */}
        <hr className="border-t border-gray-200 mb-10" />

        {/* 4. Content Section */}
        <div className="flex flex-col lg:flex-row gap-12">
          
          {/* Left Side: Paragraphs and Visit Button */}
          <div className="flex-1 space-y-6">
            <p className="text-[17px] leading-relaxed text-[#444]">
              The Dental Technology Show (DTS) is the flagship exhibition for the
              Dental Laboratories Alliance and works in partnership with the
              Dentistry Show. DTS has a dedicated website which includes
              exhibitor and visitor information. Please click the button below for
              more details.
            </p>

            <p className="text-[17px] leading-relaxed text-[#444]">
              If you are a DLA member, look out for the additional benefits
              available to you for the show on the DTS website. If you are a DLA
              Affiliate Member, don't forget you are entitled to a significant
              discount for exhibiting at the DTS.
            </p>

            {/* Visit Website Button */}
            <div className="pt-6">
              <button className="bg-[#2e4a9e] hover:bg-[#243a7a] text-white px-5 py-3 rounded-sm text-lg font-medium transition-colors">
                Visit the DTS Website &gt;
              </button>
            </div>
          </div>

          {/* Right Side: Image and Register Button */}
          <div className="flex-1 flex flex-col items-center lg:items-end">
            <div className="w-full max-w-md">
              {/* Logo Image */}
              <img 
                src="/image1.jpg" 
                alt="DTS Logo" 
                className="w-full h-auto mb-16"
              />
              
              {/* Register Button - Aligned to bottom right like image */}
              <div className="flex justify-center lg:justify-end">
                <button className="bg-[#2e4a9e] hover:bg-[#243a7a] text-white px-8 py-3 rounded-sm text-lg font-medium transition-colors">
                  Register Today &gt;
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dts;